import React from 'react';
import Select from 'react-select';
import * as apiCaller from '../../../../helpers/apiCaller'
import serviceUrls from '../../../../constants/serviceUrls';
import uiHelpers from '../../../../helpers/uiHelpers';
import moment from 'moment';
import { ArrowLeft, ArrowRight, Dot} from '../../../../components/tools/Icons';
import { InputText } from '../../../../components/tools/BootstrapControls';
import SimCardDetailsAndEdit from './SimCardDetailsAndEdit';
import { convertSimCardStatus } from '../../../../helpers/converters';


const statusOptions =[
    {value:'',label:'Select...'},
    {value:'IDLE',label:'Idle'},
    {value:'ACTIVATED',label:'Activated'},
    {value:'ARCHIVED', label:'Archived'}
];

const initState = {
    iccid:'',
    label:'',
    lidVendorSelect:null,
    disableSearchForm:false,
    lidVendorOptions:[],
    statusSelected:statusOptions[0],
    searchResult:null,
    simCardSelected:null
}




class ManagingSimCards  extends React.Component {

    constructor(props) {
        super(props);
        this.state = JSON.parse(JSON.stringify(initState));
    }

    async componentDidMount() {
        this.refreshLidVendors();
    }

    onIccidChanged  = (e) => {this.setState({iccid:e.target.value});}
    onLabelChanged  = (e) => {this.setState({label:e.target.value});}
    onLidVendorChanged =(o) =>{this.setState({lidVendorSelect : o});}
    onStatusSelectionChanged = (o) =>{this.setState({statusSelected : o});}
    onDetailsClicked = (simCardSelected) => {
        this.setState({simCardSelected})
    }

    onBackBtnClicked = () => {
        this.setState({simCardSelected:null}, this.search)
    }

    refreshLidVendors = async () => {
        this.setState({callingBackend:true});
        await apiCaller.get(serviceUrls.admin.getAllLidVendors)
        .then((data)=>{
            const options = [
                {label:'Select...', italic:true, value:'', lidVendor:null},
                {label:'Unassigned', italic:false, value:'UNASSIGNED', lidVendor:null},
                ...data.lidVendors.map(l=>{return {
                    label:l.name,
                    italic:false,
                    value:'LIDVENDOR',
                    lidVendor:l
            }})]
            this.setState({lidVendorSelect:options[0], lidVendorOptions:options})
        })
        .finally(()=>{
            this.setState({disableSearchForm:false});
        });
    }

    onFormSubmit = async (e) => {
        e.preventDefault();
        await this.search();
    }

    search = async ()=>{
        uiHelpers.showProgressOnTop('Searching...');
        this.setState({disableSearchForm:true});
        await apiCaller.post(serviceUrls.admin.searchSimCards,{
            iccid : this.state.iccid,
            lidVendorId: this.state.lidVendorSelect == null ? null : this.state.lidVendorSelect.value=="LIDVENDOR" ? this.state.lidVendorSelect.lidVendor.id : null,
            unAssignedLidVendor : this.state.lidVendorSelect == null ? null : (this.state.lidVendorSelect.value=="UNASSIGNED")?true:null,
            status: (this.state.statusSelected == null || this.state.statusSelected.value=='') ? null : this.state.statusSelected.value,
            label:this.state.label
        })
        .then((data)=>{
            this.setState({searchResult : data.simcards})
        })
        .finally(()=>{
            this.setState({disableSearchForm:false});
            uiHelpers.hideProgressOnTop();
        });
    }

    renderNavigation =() => {
        if(this.state.simCardSelected) {
            return <>
                <div className='card mb-3'>
                    <div className='card-body py-1 fs-90'>
                        <span>Search</span>
                        <span className='px-2'><ArrowRight /></span>
                        <strong className='text-primary'><Dot />Sim Card Details</strong>
                    </div>
                </div>
                <div className='mb-3'>
                    <button className='btn btn-sm btn-primary me-3' onClick={this.onBackBtnClicked}><ArrowLeft /> Back to Search</button>
                </div>
            </>
        }
        return <div className='card mb-3'>
            <div className='card-body py-1 fs-90'>
                <strong className='text-primary'><Dot /> Search</strong>
                <span className='px-2'><ArrowRight /></span>
                <span className='text-muted fs-80'>Sim Card Details</span>
            </div>
        </div>
    }

    renderSearchSection =() => {
        return <>
            <form action={""} onSubmit={this.onFormSubmit} >
                <div class="row mb-3">
                    <div class="col-md-4">
                        <InputText
                            value={this.state.iccid} 
                            disabled={this.state.disableSearchForm}
                            onChange={this.onIccidChanged}
                            label={<>ICCID</>}
                        />
                    </div>
                    <div class="col-md-6">
                        <label className='form-label'>Assigned LID Vendor</label>
                        <Select
                            isDisabled={this.state.disableSearchForm}
                            getOptionLabel={o=>{
                                if(o.value == 'UNASSIGNED') {
                                    return <i className='text-muted'>{o.label}</i>
                                } else if (o.value=='LIDVENDOR') {
                                    return <span>{o.label} {o.lidVendor.active==false && <span className='text-danger fs-80'>(Inactive)</span>} </span>
                                } else {
                                    return <span className='text-muted fs-80'>{o.label}</span>
                                }
                            }}
                            getOptionValue={o=>o}
                            options={this.state.lidVendorOptions}
                            onChange={this.onLidVendorChanged}
                            value={this.state.lidVendorSelect}
                        />
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4">
                        <label className='form-label'>Status</label>
                        <Select
                            isDisabled={this.state.disableSearchForm}
                            getOptionLabel={o=>{ 
                                if(o.value =='') return <span className='text-muted fs-80'>{o.label}</span>;
                                return o.label
                            }}
                            getOptionValue={o=>o}
                            options={statusOptions}
                            onChange={this.onStatusSelectionChanged}
                            value={this.state.statusSelected}
                        />
                    </div>
                    <div class="col-md-6">
                        <InputText
                            value={this.state.label} 
                            disabled={this.state.disableSearchForm}
                            onChange={this.onLabelChanged}
                            label={<>Label</>}
                        />
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-10">
                        <button type="submit" class="btn btn-primary me-2" disabled={this.state.disableSearchForm}>Search</button>
                    </div>
                </div>

            </form>

            {this.state.searchResult != null && <>
                <table className="table table-striped fs-90">
                <thead>
                    <tr>
                        <th style={{width:"180px"}}>
                            ICCID
                        </th>
                        <th style={{width:"100px"}}>
                            Status
                        </th>
                        <th style={{width:"150px"}}>
                            Created Date
                        </th>
                        <th style={{width:"180px"}}>
                            Created By
                        </th>
                        <th style={{width:"180px"}}>
                            LID Vendor
                        </th>
                        <th>
                            Label
                        </th>
                        <th style={{width:"80px"}}></th>
                        
                    </tr>
                </thead>
                <tbody>
                    {this.state.searchResult.length==0 && <tr>
                        <td colSpan={7} className='bg-light text-center'><i>No result found</i></td>
                    </tr>}

                    {this.state.searchResult.map((record)=> <tr>
                        <td>
                            {record.iccid}
                        </td>
                        <td className="text-break">
                            {convertSimCardStatus(record.status)}
                        </td>
                        <td className="text-break">
                            {moment((new Date(record.createdDate))).format('DD/MM/YYYY h:mma')}
                        </td>
                        <td>
                            {record.createdBy.firstname} {record.createdBy.lastname}
                        </td>
                        <td>
                            {record.lidVendor ? record.lidVendor.name : <i className='text-muted'>Unassigned</i> }
                        </td>
                        <td>
                            {record.label}
                        </td>
                        <td>
                            <button disabled={this.state.disableSearchForm} onClick={()=>this.onDetailsClicked(record)} className='btn btn-primary btn-sm'>Details</button>
                        </td>
                        
                    </tr>)}
                </tbody>
            </table>
            </>}
        </>
    }

    renderSimCardDetails = () => {
        return <SimCardDetailsAndEdit  iccid={this.state.simCardSelected.iccid} />
    }

    render() {
        return <>
            <hr/>
            {this.renderNavigation()}
            {this.state.simCardSelected ? this.renderSimCardDetails() : this.renderSearchSection()}
        </>
    }
}

export default ManagingSimCards;


